import { useQuery } from '@tanstack/react-query';
import kitService from 'v2/services/kit';

export function useAddressKitInfo(enabled = false) {
  return useQuery({
    queryKey: ['addressKitInfo'],
    queryFn: () => kitService.getBeltKitInfo(),
    enabled
  });
}
